export default "/244251c0bcaafc72a86f56c869c477c7.jpg";